import {useCallback, useState} from 'react';

import {useSubscribeToNotificationsQuery} from '@dms/api/appsync';
import {downloadDataGridExport, handleApiError, notificationTypes} from '@dms/shared';

import {ApiError, parseDate} from 'shared/web';

import {formatDataGridExportDate, StartedExport} from 'features/eag-grid';

export function useDownloadExportedFiles() {
  const [pendingExportIds, setPendingExportIds] = useState<Set<string>>(new Set());

  useSubscribeToNotificationsQuery((notification) => {
    if (notification.type !== notificationTypes.DATAGRID_EXPORT) {
      return;
    }

    const {exportId, dataGridCode, exportedAt} = notification.payload;

    if (!pendingExportIds.has(exportId)) {
      return;
    }

    downloadDataGridExport({
      exportId,
      gridCode: dataGridCode,
      exportedAt: exportedAt ? formatDataGridExportDate(parseDate(exportedAt)) : '',
    })
      .then(() => {
        setPendingExportIds((prev) => {
          const next = new Set(prev);
          next.delete(exportId);
          return next;
        });
      })
      .catch((error: ApiError) => handleApiError(error));
  });

  const handleExportSuccessfullyStarted = useCallback((startedExport: StartedExport) => {
    setPendingExportIds((prev) => new Set(prev).add(startedExport.exportId));
  }, []);

  return {
    handleExportSuccessfullyStarted,
  };
}
